import React from 'react';
export function Footer() {
  return <footer className="max-w-3xl mx-auto text-center" data-id="element-201">
      <div className="text-[#A855F7] text-2xl font-black tracking-widest mb-4" data-id="element-202">
        💪 VÉRTICE DIGITAL™
      </div>
      <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-203">
        El sistema de recursos N°1 para instructores de Pilates en Argentina.
      </p>
      <p className="text-gray-400 text-sm italic mb-6 font-bold" data-id="element-204">
        Porque enseñar Pilates no debería costarte todos los domingos del año.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-205">
        <span data-id="element-206">📧 atencion.verticedigital@gmail.com</span>
        <span className="hidden sm:inline" data-id="element-207">•</span>
        <span data-id="element-208">📲 @verticedigital</span>
        <span className="hidden sm:inline" data-id="element-209">•</span>
        <span data-id="element-210">🌐 www.verticedigital.store</span>
      </div>

      <div className="h-px bg-[#A855F7]/20 mb-6" data-id="element-211" />
      <p className="text-gray-400 text-xs mb-2" data-id="element-212">
        © Vértice Digital™ 2026 — Todos los derechos reservados.
      </p>
      <p className="text-gray-500 text-xs mb-6" data-id="element-213">
        Prohibida la reproducción y redistribución sin autorización expresa.
      </p>
      <p className="text-gray-500 text-xs font-bold tracking-widest" data-id="element-214">
        💪 "La próxima clase puede ser la mejor que diste."
      </p>
    </footer>;
}